  

 // categoryContent内のli aをクリックした時の処理
document.querySelectorAll('.categoryContent > a').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault(); // デフォルトのリンク動作を防止

    const currentNav = this.nextElementSibling; // クリックされたリンクの次の要素を取得

    // 他のすべてのcategoryChildNavigationからactiveクラスを削除
    document.querySelectorAll('.categoryChildNavigation').forEach(nav => {
      if (nav !== currentNav) {
        nav.classList.remove('active');
      }
    });

    // クリックされたリンクの次の要素にactiveクラスをトグル
    currentNav.classList.toggle('active');
  });
});

// closeButtonをクリックした時の処理
document.querySelectorAll('.closeButton').forEach(button => {
  button.addEventListener('click', function() {
    // クリックされたcloseButtonの親要素であるcategoryChildNavigationからactiveクラスを削除
    this.closest('.categoryChildNavigation').classList.remove('active');
  });
});

// link-arrowクラスに対するreturn false処理
document.querySelectorAll('.link-arrow').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();  // デフォルトのリンク動作を無効化
    return false;  // イベントの伝播を止めるためにfalseを返す
  });
});


// jQueryによるcategoryChildクリック処理
$(function() {
  $('.categoryChild').click(function() {
    $(this).toggleClass('open');
    $(this).children('.childLinks').stop().slideToggle(500);
  });
});

  